import React from "react";
import { Link } from "react-router-dom";

import { StyledColumnTitle } from "./style";

interface Props {
  linkText: string;
  linkTo: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  externalLink?: boolean;
}

const ColumnTitle: React.FC<Props> = ({
  linkText,
  linkTo,
  onClick,
  externalLink = false,
}: Props) => (
  <StyledColumnTitle>
    {externalLink ? (
      <a
        href={linkTo}
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkText}
      </a>
    ) : (
      <Link to={linkTo} onClick={onClick}>
        {linkText}
      </Link>
    )}
  </StyledColumnTitle>
);

export default ColumnTitle;
